import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import * as React from 'react'

const TrendUpIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            {/* Eixo */}
            <path d="M4 18V6M4 18H20" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />

            {/* Linha do gráfico */}
            <path
                d="M6 14L10 10L13 13L18 7"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    )
}

export default TrendUpIcon
